/*!

=========================================================
* Argon Dashboard PRO React - v1.2.1
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-pro-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
// reactstrap components
import { useSelector } from 'react-redux'
import {
  Button,
  Container,
  Row,
  Col,
  CardTitle,
  CardBody,
  Card,
} from 'reactstrap'

import './profileHeader.css'

function ProfileHeader() {
  const auth = useSelector((state) => state.auth)

  return (
    <>
      <div
        className='header pb-6 d-flex align-items-start'
        style={{
          minHeight: '500px',
          backgroundImage:
            'url("' + require('assets/img/theme/team-5.jpg').default + '")',
          backgroundSize: 'cover',
          backgroundPosition: 'center top',
        }}
      >
        <span className='mask bg-gradient-dark opacity-3' />

        <Container className='d-flex align-items-center mt-6' fluid>
          <Row className='information-container'>
            <Col lg='8'>
              <Row>
                <Col lg='12' xl='10'>
                  <h1 className='display-2 text-white mt--3'>
                    Hello {auth.user.first_name}
                  </h1>
                  <p className='text-white mt-0'>
                    This is your profile page. You can see the progress you've
                    made with your work and manage your profile.
                  </p>
                </Col>
              </Row>
            </Col>
            {/* <Col lg='5' xl='4' xxl='3'>
							<Card className='bg-gradient-danger border-0 ml-3' tag='h5'>
								<CardBody>
									<Row>
										<div className='col mt-lg-4'>
											<CardTitle className='text-uppercase text-muted mb-0 text-white'>
												Performance ThiS Week
											</CardTitle>
											<span className='h2 font-weight-bold mb-0 text-white'>
												49,65%
											</span>
										</div>
										<Col className='col-auto my-auto'>
											<div className='icon icon-shape bg-white text-dark rounded-circle shadow'>
												<i className='ni ni-spaceship' />
											</div>
										</Col>
									</Row>
								</CardBody>
							</Card>
						</Col> */}
          </Row>
        </Container>
      </div>
    </>
  )
}

export default ProfileHeader
